/**
 * 导入导出
 */
import Cookies from 'js-cookie'
import Qs from 'qs'

export default {
  data(){
    return {
      // 批量导入
      uploadVisible: false,
      dialogImportForm: {
        submitting: true
      },
      // 导出
      exportSubmitting:false
    }
  },
  methods: {
    // 批量导入
    onCloseDialogImport() {
      this.uploadVisible = false;
      this.dialogImportForm.submitting = false;
      this.$refs.$dialogImport.clearFiles();
    },
    // 导入错误提示
    importError(res) {
      const errDataTitle = '导入文件存在异常';
      const errDataList = res['rspDesc'];
      let errorList = [];
      try {
        errorList = errDataList.split('\n');
      } catch (e) {
        errorList = ['文件解析异常'];
        console.warn('文件异常信息解析错误:', e);
      }
      let li = '';
      errorList.forEach(item => {
        li += `<li><span>${item}</span></li>`
      });
      const errorReason = li ? `<div class="stationAccount-batch-import-error"><ul>${li}</ul></div>` : '';
      if (li) {
        this.$alert(errorReason, errDataTitle, {
          dangerouslyUseHTMLString: true,
          center: true,
          type: 'error',
        }).then(() => {}) .catch(() => { });
      }
      this.$refs.$dialogImport.clearFiles();
      this.dialogImportForm.submitting = true;
    },
    handleImportSuccess(res) {
      return new Promise((resolve, reject)=>{
        if (res['rspCode'] == 'success') {
          // 成功提示
          this.$message.success('上传成功');
          this.onCloseDialogImport();
          resolve();
        } else {
          // 失败提示--及后端返回的失败详情
          this.importError(res);
          this.$refs.$dialogImport.clearFiles();
          this.dialogImportForm.submitting = false;
          reject();
        }
      });
    },
    handleImportUploadFile(item){
      return new Promise((resolve, reject)=>{
        try {
          this.dialogImportForm.submitting = true;
          // 上传接口
          resolve(item.file);
        }catch (e) {
          console.warn('uploadFile error:',e);
          if(typeof e.data === 'object'){
            this.importError(e.data);
          }else {
            this.$refs.$dialogImport.clearFiles();
            this.dialogImportForm.submitting = true;
          }
          reject(e);
        }
      })
    },
    /**
     * 导出公共方法
     * @param exportParams 导出参数
     * @param exportUrl 导出请求地址
     * @param cookiePath 导出临时cookie标识
     */
    queryExport(exportParams,exportUrl,cookiePath='/export'){
      try {
        this.exportSubmitting = true;
        const _timestamp = new Date().getTime()+ parseInt(Math.random()*(100+1),10);
        // 导出参数
        const _exportParams = {
          ...exportParams,
          timestamp:_timestamp
        };
        let param = Qs.stringify(_exportParams);
        // 导出地址
        const url = `${exportUrl}${param?'?'+param:param}`;
        console.log('export url:',url);
        window.location.href= url;
        let count =0;
        this.timeInterval && clearInterval(this.timeInterval);
        this.timeInterval = setInterval(()=>{
          count++;
          const getTimesTamp = Cookies.get('timestamp');
          if(getTimesTamp){
            clearInterval(this.timeInterval);
            this.exportSubmitting = false;
            Cookies.remove('timestamp',{ path:cookiePath });
          }else if(count===60){
            clearInterval(this.timeInterval);
            this.exportSubmitting = false;
            Cookies.remove('timestamp',{ path:cookiePath });
          }
        },500)
      } catch (e) {
        console.warn('onExport error:',e);
        this.exportSubmitting = false;
      }
    }
  }
}
